<template>
  <header-page :header-props="headerProps" :sticky-header="sticky">
    <slot class="flex-1"/>
  </header-page>
</template>

<script>
import HeaderPage from './HeaderPage.vue';
import Colors from '../scss/riseup-js-colors.module.scss';
import { COLOR_VARIANTS } from '../utils/layout-consts';

export default {
  name: 'LogoPage',
  components: { HeaderPage },
  props: {
    actions: {
      type: Array,
      required: false,
    },
    backgroundColor: {
      type: String,
      required: false,
    },
    backgroundColorVariant: {
      type: String,
      validator: value => COLOR_VARIANTS.includes(value),
    },
    textColor: {
      type: String,
      default: Colors.riseupBlack,
    },
    logoColor: {
      type: String,
      default: Colors.riseupYellow,
    },
    sticky: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    headerProps() {
      return {
        showLogo: true,
        bottomBorder: true,
        rightActions: this.actions,
        backgroundColor: this.backgroundColor,
        backgroundColorVariant: this.backgroundColorVariant,
        textColor: this.textColor,
        logoColor: this.logoColor,
      };
    },
  },
};
</script>

<style scoped lang="scss">

</style>
